import React from "react";

const ArrowBack = () => {
  return (
    <svg
      width="18"
      height="32"
      viewBox="0 0 18 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0616 0.729379C17.5942 1.26191 17.6426 2.09524 17.2069 2.68246L17.0616 2.8507L4.12298 15.79L17.0616 28.7294C17.5942 29.2619 17.6426 30.0952 17.2069 30.6825L17.0616 30.8507C16.5291 31.3832 15.6958 31.4316 15.1086 30.9959L14.9403 30.8507L0.940317 16.8507C0.407784 16.3182 0.359371 15.4848 0.79508 14.8976L0.940317 14.7294L14.9403 0.729379C15.5261 0.143592 16.4759 0.143592 17.0616 0.729379Z"
        fill="black"
      />
    </svg>
  );
};

export default ArrowBack;
